import Label from './styled/Label'

const FormLabel = Label

export default FormLabel
